import { Injectable } from '@angular/core';
import { TODO } from '@b2b/types/core/utils';

class Version {
  auditTrail = '';
  updatedBy = '';
  updatedAt = '';
  number = 0;
  tables: TODO[] = [];
  grids: TODO[] = [];
  images: TODO[] = [];
  removed: TODO[] = [];
  diff: Record<string, TODO> = {};
  original: Record<string, TODO> = {};
  updated: Record<string, TODO> = {};
  gridOptions: TODO[] = [];
  previousVersion: TODO = null;
  nextVersion: TODO = null;
  patchedDiff: Record<string, TODO> = {};
  rawDiff: Record<string, TODO> = {};

  constructor(data: Record<string, TODO>) {
    this.auditTrail = data.auditTrail || '';
    this.updatedBy = data.auditTrail.updatedBy || '';
    this.updatedAt = data.auditTrail.updatedAt || '';
    this.number = data.auditTrail.version || 0;
    this.tables = data.tables || [];
    this.grids = data.grids || [];
    this.images = data.images || [];
    this.removed = data.removed || [];
    this.diff = data.diff || {};
    this.original = data.previous || {};
    this.updated = data.actual || {};
    this.gridOptions = data.gridOptions || [];
    this.previousVersion = data.previousVersion || null;
    this.nextVersion = data.nextVersion || null;
    this.patchedDiff = data.patchedDiff || {};
    this.rawDiff = data.rawDiff || {};
  }
}

@Injectable({ providedIn: 'root' })
export class AuditTrailVersionHandlerService {
  public version: Record<string, TODO> = {};

  constructor() {}
  init(): void {}

  setNewVersion(model: Record<string, TODO>): void {
    this.version = new Version(model);
  }

  addToVersion(prop: string, obj: TODO) {
    this.version[prop].push(obj);
  }

  getVersion() {
    return this.version;
  }

  reset() {
    this.version = {};
  }
}
